import React, { createContext, useContext, useState, ReactNode } from 'react';
import { GenericErrorModal, GenericWarningModal } from './GenericErrorModal';

type GlobalModalContextType = {
  showError: (message: string) => void;
  showWarning: (message: string) => void;
};

const GlobalModalContext = createContext<GlobalModalContextType>({
  showError: () => {},
  showWarning: () => {},
});

export function GlobalModalProvider({ children }: { children: ReactNode }) {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [warningMessage, setWarningMessage] = useState<string | null>();

  const showError = (message: string) => {
    setErrorMessage(message);
  };

  const showWarning = (message: string) => {
    setWarningMessage(message);
  };

  const handleCloseWarning = () => {
    setWarningMessage(null);
  };

  const handleCloseError = () => {
    setErrorMessage(null);
  };

  return (
    <GlobalModalContext value={{ showError, showWarning }}>
      {children}
      <GenericErrorModal
        opened={!!errorMessage}
        message={errorMessage}
        onClose={handleCloseError}
      />
      <GenericWarningModal
        opened={!!warningMessage}
        message={warningMessage}
        onClose={handleCloseWarning}
      />
    </GlobalModalContext>
  );
}

export function useGlobalModal() {
  return useContext(GlobalModalContext);
}
